<script>
import { mapGetters } from 'vuex';
import router from '../../../../index';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';
import branchesAPI from 'dashboard/api/branches';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import PageHeader from '../../SettingsSubPageHeader.vue';
import TeamSelector from '../TeamSelector.vue';

export default {
  components: {
    Spinner,
    PageHeader,
    TeamSelector,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedTeams: [],
      isCreating: false,
      isFetching: true,
    };
  },

  computed: {
    ...mapGetters({
      teamList: 'teams/getTeams',
    }),

    branchId() {
      return this.$route.params.branchId;
    },
    headerTitle() {
      return this.$t('BRANCHES_SETTINGS.TEAMS.EDIT_TITLE', {
        branchName: this.currentBranch?.name || '',
      });
    },
    currentBranch() {
      return this.$store.getters['branches/getBranch'](this.branchId);
    },
    showTeamsList() {
      const { id } = this.currentBranch;
      return id && !this.isFetching;
    },
  },

  async mounted() {
    const { branchId } = this.$route.params;
    this.$store.dispatch('teams/get');
    try {
      this.isFetching = true;
      const response = await branchesAPI.getTeams({ branchId });
      const members = response.data.map(item => item.id);
      this.updateSelectedTeams(members);
    } catch {
      this.updateSelectedTeams([]);
    } finally {
      this.isFetching = false;
    }
  },

  methods: {
    updateSelectedTeams(newTeamList) {
      this.selectedTeams = [...newTeamList];
    },
    async addTeams() {
      this.isCreating = true;
      const { branchId, selectedTeams } = this;

      try {
        await branchesAPI.updateTeams({
          branchId,
          teamsList: selectedTeams,
        });
        useAlert(this.$t('BRANCHES_SETTINGS.TEAMS.API.SUCCESS_MESSAGE'));
        router.push({
          name: 'settings_branches_list',
        });
        this.$store.dispatch('branches/get');
        this.$store.dispatch('teams/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-auto">
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="addTeams">
      <PageHeader
        :header-title="headerTitle"
        :header-content="$t('BRANCHES_SETTINGS.TEAMS.HEADER_CONTENT')"
      />

      <div class="w-full h-full">
        <TeamSelector
          v-if="showTeamsList"
          :team-list="teamList"
          :selected-teams="selectedTeams"
          :current-branch-id="branchId"
          :update-selected-teams="updateSelectedTeams"
          :is-working="isCreating"
          :submit-button-text="$t('BRANCHES_SETTINGS.TEAMS.UPDATE_BUTTON')"
        />
        <div v-else class="flex items-center justify-center py-6">
          <Spinner class="text-n-blue-11" />
        </div>
      </div>
    </form>
  </div>
</template>
